import { create } from 'zustand'

export const AdminStore = create((set) => ({
  change_password:false,
  toggle_change_password: (val) => set((state) => ({ change_password:val }))
}))
